import { BehaviorSubject } from "rxjs";
import axios from "axios";
import { setCookie, removeCookie, getCookie } from "../_helpers/cookie";
import { handleResponse, handleSocialAuthResponse, parseJwt } from "../_helpers";
import { getConfiguredDemoOtp, isBrowserSessionDemo, isDemoMode, isDemoOtpBypassEnabled } from "../../utils/demoConfig";
import { resetBrowserSessionDemoStorage } from "../../utils/browserSessionDemoApi";
import { clearDemoTwoFactorStorage, persistRealUserIdentity } from "../../utils/demoTwoFactorHelpers";
import { refreshRealUserIdentity } from "../../utils/getUser";
import { clearAllDemoTrackBlobs } from "../../utils/demoTrackBlobStore";
const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

let token = getCookie("token");
// let refresh = getCookie("refresh");
let rememberBe = getCookie("rememberBe");
let JWT_decode = token ? parseJwt(token) : null;
let currentUserSubject = new BehaviorSubject(null);

// const getNewToken = (oldToken) => {
//   return axios({
//     method: "POST",
//     mode: 'cors',
//     url: `${API_URL}refresh-token/`,
//     data: {"refresh": oldToken},
//     headers: {
//       "Content-Type": "application/json",
//       "x-api-key": X_API_KEY,
//     }
//   }).then(res => {
//     const newToken = res.data.access;
//     setCookie("token", newToken);
//     localStorage.setItem("currentUser", JSON.stringify(newToken));
//     currentUserSubject = new BehaviorSubject(newToken)
//   }).catch(e => {
//     logoutNoRefresh();
//     currentUserSubject = new BehaviorSubject(null);
//   })
// }

if ((JWT_decode && Date.now() >= JWT_decode.exp * 1000) || !JWT_decode) {
  logoutNoRefresh();
  currentUserSubject = new BehaviorSubject(null);
} else if (rememberBe === "1") {
  setCookie("token", token);
  localStorage.setItem("currentUser", JSON.stringify(token));
  currentUserSubject = new BehaviorSubject(token);
  // getNewToken(refresh);
} else if (rememberBe === "1") {
  logoutNoRefresh();
  currentUserSubject = new BehaviorSubject(null);
}


export const authenticationService = {
  login,
  logout,
  logoutNoRefresh,
  socialAuth,
  request2FAToken,
  validateOTP,
  currentUserSubject,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject;
  }
};

function request2FAToken(user, method) {
  if (isDemoMode() || isBrowserSessionDemo()) {
    return Promise.resolve({ sent: true, method: method || "email" });
  }
  return axios
    .post(
      `${API_URL}2fa/request-token/`,
      { username: user, method },
      { headers: { "x-api-key": X_API_KEY, "Content-Type": "application/json" } },
    )
    .then(res => res.data);
}

function validateOTP(user, otp, method, tenant) {
  const trimmed = String(otp || "").trim();
  if (isDemoOtpBypassEnabled() && trimmed === getConfiguredDemoOtp()) {
    return Promise.resolve({ verified: true });
  }
  if (isDemoMode() || isBrowserSessionDemo()) {
    const isSixDigit = /^[0-9]{6}$/.test(trimmed);
    const isBackupCode = /^[A-Z0-9]{4}-[A-Z0-9]{4}$/i.test(trimmed) || /^[A-Za-z0-9]{10}$/.test(trimmed);
    if (method === "backup" ? isBackupCode : isSixDigit || isBackupCode) {
      return Promise.resolve({ verified: true });
    }
    return Promise.reject("Invalid OTP. In demo mode use a 6-digit code, a backup code (XXXX-XXXX), or REACT_APP_DEMO_OTP.");
  }
  return axios
    .post(
      `${API_URL}2fa/validate/`,
      { username: user, otp: trimmed, method, tenant_id: tenant?.id },
      { headers: { "x-api-key": X_API_KEY, "Content-Type": "application/json" } },
    )
    .then(res => res.data);
}

function login(username, password, recaptcha) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  };

  const completeLogin = () =>
    fetch(`${API_URL}users/login/`, requestOptions)
      .then(handleResponse)
      .then(user => {
        localStorage.setItem("currentUser", JSON.stringify(user.access_token));
        setCookie("token", user.access_token);
        currentUserSubject.next(user.access_token);
        persistRealUserIdentity(user);
        persistRealUserIdentity({ email: username, username });
        void refreshRealUserIdentity(user.access_token);
        return user;
      });

  const recaptchaRequestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ recaptcha })
  };

  return fetch(
    `${API_URL}users/validate-google-recaptcha/`,
    recaptchaRequestOptions
  )
    .then(handleResponse)
    .then(response => {
      if (response.valid) {
        return completeLogin();
      }
      return;
    });
}

function socialAuth(provider, authCode, redirectUri, authType) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": X_API_KEY,
    },
  };

  return fetch(
    `${API_URL}users/social-auth/?provider=${provider}&code=${authCode}&redirect_uri=${redirectUri}&auth_type=${authType}`,
    requestOptions
  )
    .then(handleSocialAuthResponse)
    .then(user => {
      localStorage.setItem("currentUser", JSON.stringify(user.access_token));
      setCookie("token", user.access_token);
      // setCookie("refresh", user.refresh);
      currentUserSubject.next(user.access_token);
      persistRealUserIdentity(user);
      void refreshRealUserIdentity(user.access_token);
      return user;
    });
}

function logout() {
  if (isBrowserSessionDemo()) {
    resetBrowserSessionDemoStorage();
  } else if (isDemoMode()) {
    clearDemoTwoFactorStorage();
    void clearAllDemoTrackBlobs();
  }
  // remove user from local storage to log user out
  localStorage.removeItem("currentUser");
  currentUserSubject = new BehaviorSubject(null);
  removeCookie("token");
  // removeCookie("refresh");
  window.location.reload();
}

function logoutNoRefresh() {
  if (isBrowserSessionDemo()) {
    resetBrowserSessionDemoStorage();
  } else if (isDemoMode()) {
    clearDemoTwoFactorStorage();
    void clearAllDemoTrackBlobs();
  }
  localStorage.removeItem("currentUser");
  currentUserSubject = new BehaviorSubject(null);
  removeCookie("token");
  // removeCookie("refresh");
}
